import React, { useEffect, useState } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import NotesContent from "./NotesContent";
import InsuranceDetails from "./InsuranceDetails";
import ServiceHistory from "./ServiceHistory";
import FinesHistory from "./FinesHistory";
import FleetInformationContent from "./FleetInformationContent";
import { FaSave, FaTimes, FaUpload, FaPaperclip } from "react-icons/fa";
import axios from "axios";
import { base_url as base_url_from_axios_config } from "../../utils/AxiosConfig";
import { base_url_image_post_api } from "../../utils/ImageCreationAPI";
import { Snackbar, Alert, Tooltip } from "@mui/material";
import dayjs from "dayjs";
import { useLocation } from "react-router-dom";

const FleetInformation = () => {
  const [value, setValue] = useState(0);
  const [dataFromFleetInfoContent, setDataFromFleetInfoContent] = useState({});
  const [dataFromInsuranceDetails, setDataFromInsuranceDetails] = useState({});
  const [dataFromNotesContent, setDataFromNotesContent] = useState("");
  const [dataFromFineHistory, setDataFromFineHistory] = useState([]);
  const [dataFromServiceHistory, setDataFromServiceHistory] = useState([]);
  const [companyCode, setCompanyCode] = useState(null);
  const [isSaveDisabled, setIsSaveDisabled] = useState(true);
  const [isEdit, setIsEdit] = useState(false);
  // const [fleetPhoto, setFleetPhoto] = useState(null);
  // const [fleetPhototFile, setFleetPhototFile] = useState(null);

  const location = useLocation();

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  useEffect(() => {
    if (location.state?.item) {
      // console.log("location.state.item in parent:", location.state.item.REG_NO);
      setIsEdit(true);
      // setDataFromNotesContent(location.state?.item);
      // fetchFineDetails(); /////work on this pending
      setIsSaveDisabled(false);
      // const vehicleRegNo = location.state.item.REG_NO;
      // fetchFleetInfo(vehicleRegNo);
    } else {
      if (dataFromFleetInfoContent?.REGNO?.length > 0 && isSaveDisabled) {
        setSnackbar({
          open: true,
          message: "Registration Number already exists, Try other number!",
          severity: "error",
        });
      }
    }
  }, [location.state]);
  // }, [isSaveDisabled, location.state]);

  const handleDuplicateRegNo = (isDuplicate) => {
    setIsSaveDisabled(isDuplicate);
    if (isDuplicate && !isEdit) {
      setSnackbar({
        open: true,
        message: "Registration Number already exists, try another!",
        severity: "error",
      });
    } else {
      setSnackbar({ open: false, message: "", severity: "" });
    }
  };

  const [base_url] = useState(base_url_from_axios_config);

  const [loginUser, setLoginUser] = useState("");

  const [userDataArray, setUserDataArray] = useState([]);
  // const [imageDescription, setImageDescription] = useState("EMPIMAGE");

  let portNumberLocal = localStorage.getItem("BondTimeportNoData");
  let portNumber = JSON.parse(portNumberLocal)[0].PORTNO;

  const handleCloseSnackbar = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    console.log("dataFromNotesContent:", dataFromNotesContent);
  }, [dataFromNotesContent]);

  useEffect(() => {
    const storedUserDataArray =
      JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
    const cmpCode = storedUserDataArray[0]?.cmpcode || null;
    setCompanyCode(cmpCode);
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const storedUserDataArray = localStorage.getItem("BondTimeLoginUserData");
      const parsedUserDataArray = JSON.parse(storedUserDataArray) || [];

      setUserDataArray(parsedUserDataArray);

      setLoginUser(
        parsedUserDataArray && parsedUserDataArray[0].salesman_name.trim(),
      );
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  // useEffect(() => {
  //   if (loginUser && companyCode && portNumber) {
  //     fetchImagePath();
  //   }
  // }, [loginUser, companyCode, portNumber]);
  // const handlePhotoUpload = (event) => {
  //   const file = event.target.files[0];
  //   if (file && file.type.startsWith("image/")) {
  //     setFleetPhoto(URL.createObjectURL(file)); // Create a preview URL
  //     setFleetPhototFile(file);
  //     // console.log("File uploaded:", file);
  //   } else {
  //     alert("Please upload a valid image file!");
  //   }
  // };

  // const fetchImagePath = async () => {
  //   try {
  //     // console.log("calling ImgPath");
  //     // console.log(
  //     //   `fetchImagePath-->${base_url}/api/MasterCount/${companyCode}/IMAGEPATH/${loginUser}/EMPIMAGE`,
  //     // );

  //     const response = await axios.get(
  //       `${base_url}/api/MasterCount/${companyCode}/IMAGEPATH/${loginUser}/EMPIMAGE`,
  //     );

  //     if (response.status === 200) {
  //       setImagePath(response.data);
  //     }
  //   } catch (error) {
  //     console.log("fetchImagePathErr", error);
  //   }
  // };

  // no need for now fleet image feature
  // const sendFleetImage = async () => {
  //   if (!fleetPhoto) {
  //     setSnackbar({
  //       open: true,
  //       message: "No picture selected",
  //       severity: "warning",
  //     });
  //     return;
  //   }

  //   if (!dataFromFleetInfoContent.REG_NO) {
  //     setSnackbar({
  //       open: true,
  //       message: "EmpId Required",
  //       severity: "warning",
  //     });
  //     return;
  //   }

  //   try {
  //     const formData = new FormData();
  //     formData.append("DOC_CODE", dataFromFleetInfoContent.REG_NO);
  //     formData.append("DOC_TYPE", "DOCIMAGE");
  //     formData.append("file", fleetPhototFile);
  //     formData.append("cmpcode", companyCode);
  //     formData.append("IMGBASE64", "XX");
  //     formData.append("IMAGEPATH", imagePath[0].imagepath);

  //     const config = {
  //       headers: {
  //         "Content-Type": "multipart/form-data", // Ensure the correct content type
  //       },
  //     };

  //     // console.log("formData", formData);

  //     const response = await axios.post(
  //       `${base_url_image_post_api}/api/Image/upload`,
  //       formData,
  //       config,
  //     );

  //     // console.log("Response:", response.data);

  //     if (response.status === 200) {
  //       setSnackbar({
  //         open: true,
  //         message: "Fleet Image Uploaded succesfully!",
  //         severity: "success",
  //       });
  //       setImageDescription("");
  //       setFleetPhoto("");
  //       setFleetPhototFile("");
  //     }
  //   } catch (error) {
  //     console.error("Error uploading data:", error.response || error.message);
  //     setSnackbar({
  //       open: true,
  //       message: "Error While Uploading",
  //       severity: "error",
  //     });
  //   }
  // };

  const onSaveFleetInfo = async () => {
    // console.log("Fleet info clicked!");

    const storedUserDataArray =
      JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
    const companyCode = storedUserDataArray[0]?.cmpcode || null;

    const payload = [
      {
        CmpCode: companyCode || "",
        mode: isEdit ? "EDIT" : "ENTRY",
        EmpId: dataFromFleetInfoContent.REG_NO || "",
        AlternateID:
          dataFromFleetInfoContent.ENGINE_NO ||
          dataFromFleetInfoContent["ENGINE NO"] ||
          "",
        Status: dataFromFleetInfoContent.STATUS || "",
        Title: dataFromFleetInfoContent.TYPE || "",
        FistName: dataFromFleetInfoContent.MAKE || "",
        MiddleName: dataFromFleetInfoContent.MODEL || "",
        LastName: "",
        DOB:
          dataFromFleetInfoContent.REG_DATE ||
          dataFromFleetInfoContent["REGISTRAION ON"] ||
          "",
        MaritalStatus: "",
        Gender: "",
        Nationality: "",
        Height:
          dataFromFleetInfoContent.CHASIS_NO ||
          dataFromFleetInfoContent.CHASSIS ||
          "",
        Weight:
          dataFromFleetInfoContent.PURCH_AMOUNT ||
          dataFromFleetInfoContent.PURCHASE_AMOUNT ||
          "",
        JoinDate:
          dataFromInsuranceDetails.START_DATE ||
          dataFromInsuranceDetails.INSURANCE_START ||
          "",
        JobTitle:
          dataFromInsuranceDetails.COMPANY ||
          dataFromInsuranceDetails.INS_COMPANY ||
          "",
        JobType:
          dataFromInsuranceDetails.INSUR_TYPE ||
          dataFromInsuranceDetails.insuranceType ||
          "",
        ShiftGroup: "",
        Department:
          dataFromFleetInfoContent.BRANCH ||
          dataFromFleetInfoContent.DEPARTMENT ||
          "",
        Division: "",
        Grade: "",
        BankAccountNo:
          dataFromInsuranceDetails.ACC_NO ||
          dataFromInsuranceDetails.ACCOUNTNO ||
          "",
        BankName:
          dataFromInsuranceDetails.SERIAL_NO ||
          dataFromInsuranceDetails.SERIALNO ||
          "",
        AgentID: dataFromInsuranceDetails.PREMIUM || "",
        CurrentAddress: "",
        HomeAddress: "",
        HomeAirport: "",
        WorkMobile: "",
        PersonalMobile: "",
        WorkPhone: "",
        PersonalPhone: "",
        WorkEmail: "",
        PersonalEmail: "",
        PassportNo: "",
        PassportIssueDate: null,
        PassportExpiryDate: null,
        PassportPlaceofIssue: "",
        PassportCountryofIssue: "",
        EmiratesId: "",
        EmiratesIdExpiryDate: null,
        VisaNo:
          dataFromFleetInfoContent.TRAFFIC_CODE_NO ||
          dataFromFleetInfoContent.TRAFFICCODE ||
          "",
        VisaExpiryDate:
          dataFromFleetInfoContent.EXPIRATION_DATE ||
          dataFromFleetInfoContent.REG_EXPIRY ||
          "",
        InsuranceNo:
          dataFromFleetInfoContent.SALIK_ACC_NO ||
          dataFromFleetInfoContent.SALIK_ACCOUNT ||
          "",
        InsuranceExpiryDate:
          dataFromInsuranceDetails.END_DATE ||
          dataFromInsuranceDetails["INSURANCE EXPIRY"] ||
          "",
        DrivingLicenceNo: "",
        DrivingLicenceExpiryDate: null,
        PersonId: "",
        PersonIdExpiryDate: null,
        BasicPay: 0,
        Allowances_OT: 0.0,
        Allowances_NOT: 0.0,
        NetSalary: 0.0,
        NormalHrs: 0.0,
        HourlyWage: 0.0,
        OTrate: 0,
        SplOtRate: 0,
        photo: "",
        Active:
          dataFromFleetInfoContent?.ACTIVE ||
          dataFromFleetInfoContent?.Active ||
          "Yes",
        Memos:
          dataFromFleetInfoContent.CURR_CUSTODIAN ||
          dataFromFleetInfoContent.CURRENT_CUSTODIAN ||
          "",
        Notes: dataFromNotesContent || "",
        SalaryAc: "",
        AdvanceAc: "00000000",
        RegOwner:
          dataFromFleetInfoContent.REG_OWNER ||
          dataFromFleetInfoContent.regowner ||
          "",
        SalikPin:
          dataFromFleetInfoContent.SALIK_PIN ||
          dataFromFleetInfoContent.SalikPin ||
          "",
      },
    ];

    try {
      const apiURL = `${base_url}/api/VehicleInfoReg`;
      const config = { headers: { "Content-Type": "application/json" } };
      const response = await axios.post(apiURL, payload, config);

      const data = response.data;
      // console.log("Saved Fleet info:", data);
      await saveFineHistory();
      await saveServiceHistory();
      resetAllData();
      setSnackbar({
        open: true,
        message: "Fleet info , insurance details and notes saved successfully",
        severity: "success",
      });
    } catch (error) {
      console.error("Error While Saving Fleet Info:", error);
      setSnackbar({
        open: true,
        message: "Failed to save fleet info",
        severity: "error",
      });
    }
  };

  const resetAllData = () => {
    setDataFromFleetInfoContent({});
    setDataFromInsuranceDetails({});
    setDataFromNotesContent("");
    setDataFromFineHistory([]);
    setDataFromServiceHistory([]);
    setIsSaveDisabled(true);
    setIsEdit(false);
    setValue(0);
  };

  const saveFineHistory = async () => {
    const storedUserDataArray =
      JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
    const companyCode = storedUserDataArray[0]?.cmpcode || null;

    const fineHistoryPayload = (dataFromFineHistory || [])
      ?.filter((item) => item.Amount).map((item) => ({
      CmpCode: companyCode,
      EmpID: dataFromFleetInfoContent.REG_NO,
      Custodian: item.Custodian || "",
      FDate: item.Fine_Date || item.FDate || null,
      PDate: item.Paid_Date || item.PDate || null,
      Amount: item.Amount || "0",
      Location: item.Location || "",
      DTime: item.Fine_Date || item.DDate || "",
      Remarks: item.Remarks || "",
    }));

    if (fineHistoryPayload.length === 0) return;

    try {
      const apiURL = `${base_url}/api/VehicleFines`;
      const config = { headers: { "Content-Type": "application/json" } };
      const response = await axios.post(apiURL, fineHistoryPayload, config);

      const data = response.data;
      // console.log("Saved Fine history:", data);
    } catch (error) {
      setSnackbar({
        open: true,
        message: "Failed to save fleet info",
        severity: "error",
      });
      console.error("Error While Saving Fine history:", error);
      throw error;
    }
  };

  const saveServiceHistory = async () => {
    const storedUserDataArray =
      JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
    const companyCode = storedUserDataArray[0]?.cmpcode || null;

    console.log("dataFromServiceHistory before save:", dataFromServiceHistory);
    const payload = (dataFromServiceHistory || [])
      ?.filter((item) => item.Amount)
      .map((item) => ({
        CmpCode: companyCode,
        EmpID: dataFromFleetInfoContent.REG_NO || "",
        AllowanceType: item.Type || item.SERVICE_TYPE || "",
        Amount: item.Amount || "",
        ADate: item.Date || item.ADate || "",
        AffectOTCalc: item.ServiceDetails || item.AffectOTCalc || "",
      }));

    if (payload.length === 0) return;

    try {
      const apiURL = `${base_url}/api/VehicleService`;
      const config = { headers: { "Content-Type": "application/json" } };
      const response = await axios.post(apiURL, payload, config);

      const data = response.data;
      console.log("Saved Service history:", data);
    } catch (error) {
      console.error("Error While Saving Service history:", error);
      throw error;
    }
  };

  const isSaveButtonDisabled =
    isSaveDisabled || !dataFromFleetInfoContent.REG_NO;

  // useEffect(() => {
  //   console.log(
  //     "formdata in fleet parent 1. Initial :",
  //     dataFromFleetInfoContent,
  //   );
  // }, []);

  // useEffect(() => {
  //   console.log("formdata in fleet parent  2. :", dataFromFleetInfoContent);
  // }, [dataFromFleetInfoContent]);

  useEffect(() => {
    console.log(
      "formdata in insurance parent 1. Initial :",
      dataFromInsuranceDetails,
    );
  }, []);

  useEffect(() => {
    console.log("formdata in insurance parent  2. :", dataFromInsuranceDetails);
  }, [dataFromInsuranceDetails]);

  return (
    <div className="">
      <div className="flex  items-center mb-4">
        <div className="w-1 h-8 bg-gradient-to-r from-[#2663EB] to-blue-400 rounded-full mr-2"></div>

        <h6 className="text-xl font-bold text-gray-900">
          <span className="bg-gradient-to-r from-[#2663EB] to-blue-600 bg-clip-text text-transparent">
            FLEET INFORMATION
          </span>

          {/* <button
            onClick={saveFineHistory}
            className="bg-blue-500 p-4 text-white"
          >
            Save Fine History
          </button> */}
          {/* <button
            onClick={saveServiceHistory}
            className="bg-green-500 p-4 text-white"
          >
            Save Service History{" "}
          </button> */}
        </h6>
      </div>
      <div className="flex justify-center items-center gap-8">
        {/* <div className=" bg-white w-[16vw] h-[79vh] p-4 border border-gray-200 rounded-lg">
          <div class="group relative  h-[200px] bg-gray-100 rounded-md overflow-hidden shadow-[0_0_0_5px_rgba(255,255,255,0.5)] transition-all duration-700 ease-[cubic-bezier(0.175,0.885,0.32,1.275)] hover:scale-105 hover:shadow-[0_8px_16px_rgba(255,255,255,0.2)] perspective-[1000px]">
            <div class="absolute inset-0 bg-gray-100  border border-gray-100 p-5 flex flex-col justify-center origin-bottom rotate-x-[-90deg] group-hover:rotate-x-0 transition-all duration-700 ease-[cubic-bezier(0.175,0.885,0.32,1.275)]">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                class="w-22 h-22 fill-gray-700 transition-all duration-700 group-hover:scale-0"
              >
                <path d="M20 5H4V19L13.2923 9.70649C13.6828 9.31595 14.3159 9.31591 14.7065 9.70641L20 15.0104V5ZM2 3.9934C2 3.44476 2.45531 3 2.9918 3H21.0082C21.556 3 22 3.44495 22 3.9934V20.0066C22 20.5552 21.5447 21 21.0082 21H2.9918C2.44405 21 2 20.5551 2 20.0066V3.9934ZM8 11C6.89543 11 6 10.1046 6 9C6 7.89543 6.89543 7 8 7C9.10457 7 10 7.89543 10 9C10 10.1046 9.10457 11 8 11Z" />
              </svg>
            </div>
          </div>

          <div className="flex gap-4  flex-col mt-6">
           

            <button
              onClick={sendFleetImage}
              className="flex items-center gap-2 px-3 py-1.5 text-sm font-medium bg-blue-500 text-white rounded-md hover:bg-blue-600 transition"
            >
              <FaUpload />
              Upload
            </button>

            <div>
              <label
                htmlFor="PhotoUpload"
                className="block text-sm font-medium text-gray-700 mb-1"
              >
                Upload Photo
              </label>
              <input
                id="PhotoUpload"
                type="file"
                accept="image/*"
                onChange={handlePhotoUpload}
                className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 
                          file:rounded-md file:border-0 file:text-sm file:font-semibold 
                          file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100 
                               cursor-pointer"
              />
            </div>

            <button
              onClick={onSaveFleetInfo}
              className="flex items-center gap-2 px-3 py-1.5 text-sm font-medium bg-green-500 text-white rounded-md hover:bg-green-600 transition"
            >
              <FaSave />
              Save
            </button>

            {/* <button className="flex items-center gap-2 px-3 py-1.5 text-sm font-medium bg-purple-500 text-white rounded-md hover:bg-purple-600 transition">
              <FaPaperclip />
              Attachment
            </button> 
          </div>
        </div> */}
        <div className="bg-white w-full   p-3 border border-gray-200 rounded-lg">
          <div className=" h-full w-full flex flex-col justify-left ">
            <div className="w-full ">
              <Tabs
                value={value}
                onChange={handleChange}
                sx={{
                  "& .MuiTab-root": {
                    fontFamily: "inherit",
                    // textTransform: "none", // optional (removes uppercase)
                    fontWeight: 600,
                  },
                }}
              >
                <Tab label="Fleet Information" />
                <Tab label="Insurance Details" />
                <Tab label="Service History" />
                <Tab label="Fines History" />
                <Tab label="Notes" />
              </Tabs>
              <div className="mt-3 flex-1 overflow-auto">
                <div className={value !== 0 ? "hidden" : ""}>
                  <FleetInformationContent
                    value={dataFromFleetInfoContent}
                    onChange={setDataFromFleetInfoContent}
                    // duplicateRegNo={setIsSaveDisabled}
                    duplicateRegNo={handleDuplicateRegNo}
                  />
                </div>

                <div className={value !== 1 ? "hidden" : ""}>
                  <InsuranceDetails
                    value={dataFromInsuranceDetails}
                    onChange={setDataFromInsuranceDetails}
                  />
                </div>

                <div className={value !== 2 ? "hidden" : ""}>
                  <ServiceHistory
                    value={dataFromServiceHistory}
                    onChange={setDataFromServiceHistory}
                  />
                </div>

                <div className={value !== 3 ? "hidden" : ""}>
                  <FinesHistory
                    value={dataFromFineHistory}
                    onChange={setDataFromFineHistory}
                  />
                </div>

                <div className={value !== 4 ? "hidden" : ""}>
                  <NotesContent
                    value={dataFromNotesContent}
                    onChange={setDataFromNotesContent}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbar.severity}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
      <div className=" mt-4  flex items-center justify-center">
        <Tooltip title="Please fill Registration Number" disableHoverListener={!isSaveButtonDisabled}>
          <span>
            <button
              disabled={isSaveButtonDisabled}
              onClick={onSaveFleetInfo}
              className={`flex items-center gap-2 px-3 py-1.5 text-sm font-medium text-white rounded-md 
                ${isSaveButtonDisabled ? "cursor-not-allowed bg-gray-400 hover:bg-gray-600 transition" : `${isEdit ? "bg-orange-500 hover:bg-orange-600 transition" : "bg-green-500 hover:bg-green-600 transition"}`}`}
            >
              <FaSave />
              {isEdit ? `Update Fleet Info` : `Save Fleet Info`}
            </button>
          </span>
        </Tooltip>
      </div>
    </div>
  );
};

export default FleetInformation;
